module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "spinner"
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0836fbb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/transaction/Loader.vue
// module id = 1037
// module chunks = 2